import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  static values = {
    autoShow: { type: Boolean, default: true }
  }

  connect() {
    this.modal = new bootstrap.Modal(this.element);
    if (this.autoShowValue) {
      this.modal.show();
    }
    
    $(this.modal).find("[autofocus]").focus();
    Turbo.cache.exemptPageFromCache();

    // 追蹤 IME 組字狀態
    this.isComposing = false;

    // 只有當 modal 有 data-enter-submit 屬性時才添加 Enter 鍵事件監聽器
    if (this.element.hasAttribute('data-enter-submit')) {
      // 將事件監聽器添加到 modal 元素上，使用事件委派
      this.boundHandleKeydown = this.handleKeydown.bind(this);
      this.boundCompositionStart = this.handleCompositionStart.bind(this);
      this.boundCompositionEnd = this.handleCompositionEnd.bind(this);

      this.element.addEventListener('keydown', this.boundHandleKeydown);
      this.element.addEventListener('compositionstart', this.boundCompositionStart);
      this.element.addEventListener('compositionend', this.boundCompositionEnd);
    }
  }

  close() {
    this.modal.hide();
  }

  closeOnSuccess(event) {
    const fetchResponse = event.detail.fetchResponse
    if(fetchResponse && fetchResponse.statusCode === 200) {
      this.modal.hide();
    }
  }

  handleResponse(event) {
    const fetchResponse = event.detail.fetchResponse
    if(fetchResponse && fetchResponse.statusCode === 200) {
      Turbo.visit(fetchResponse.response.url)
    }
  }

  handleCompositionStart(event) {
    // 開始輸入法組字（出現底線）
    this.isComposing = true;
  }

  handleCompositionEnd(event) {
    // 結束輸入法組字（消除底線）
    this.isComposing = false;
  }

  handleKeydown(event) {
    // 檢查是否按下 Enter 鍵
    if (event.key === 'Enter' && !event.shiftKey && !event.ctrlKey && !event.altKey) {
      // 如果正在使用輸入法組字中，不送出表單
      if (this.isComposing) {
        return;
      }

      // 找到表單中的 submit 按鈕
      const submitButton = this.element.querySelector('input[type="submit"], button[type="submit"]');
      if (submitButton) {
        event.preventDefault();
        submitButton.click();
      }
    }
  }

  disconnect() {
    // 清理 Bootstrap Modal 實例和 backdrop，避免殘留
    if (this.modal) {
      this.modal.dispose();
    }

    // 只有當 modal 有 data-enter-submit 屬性時才清理事件監聽器
    if (this.element.hasAttribute('data-enter-submit')) {
      if (this.boundHandleKeydown) {
        this.element.removeEventListener('keydown', this.boundHandleKeydown);
      }
      if (this.boundCompositionStart) {
        this.element.removeEventListener('compositionstart', this.boundCompositionStart);
      }
      if (this.boundCompositionEnd) {
        this.element.removeEventListener('compositionend', this.boundCompositionEnd);
      }
    }
  }
}
